import React from "react";

export const ArrowNewIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M28.0077 14.5895L26.5877 15.9996L28.0077 17.4098L23.0574 22.3601L21.6433 20.946L26.5877 15.9996L21.6433 11.0542L23.0574 9.64014L28.0077 14.5895Z"
            fill="currentColor"
        />
        <path
            d="M4 14.9973V16.9974H24.6001V14.9973H4Z"
            fill="currentColor"
        />
    </svg>
);
